module.exports = __webpack_public_path__ + "static/media/iconmonstr-upload-6.92b3915f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/iconmonstr-upload-6.svg
// module id = 720
// module chunks = 0